import * as routerRegistry from 'router/registry';
import { flowRight as compose } from 'lodash';
import { PRODUCTS_BERN, PRODUCTS_ZURICH } from 'constants/page-names';
import { DEFAULT_REGION_SLUG } from 'constants/regions';
import { getRegionSlugByCooperative, getRegionSlugBySlug } from './get-region';

/**
 * Returns the link to the specific user dashboard depending on the active region
 * @TODO: this function should be updated as soon as we will have more regions
 * @param {string} regionSlug - any region slug
 * @return {string} path to the user dashboard
 */
function getLink(regionSlug) {
    // assuming the default region is zuerich
    if (DEFAULT_REGION_SLUG !== regionSlug) {
        return routerRegistry.get(PRODUCTS_BERN).url;
    }

    return routerRegistry.get(PRODUCTS_ZURICH).url;
}

// compositional functions to get the links properly
export const linkToDashboard = compose(getLink, getRegionSlugBySlug);
export const linkToDashboardByRoute = compose(getLink, getRegionSlugByCooperative);
export const linkToDashboardByUser = compose(getLink, getRegionSlugBySlug);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/link-to-dashboard.js